export default __webpack_public_path__ + "static/media/shoes.e618236d.jpg";